import React, { useState } from 'react'
import { Row, Col, Button, Form, Spinner } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css'
import { Link } from 'react-router-dom'
import axios from 'axios'

interface AppState {
  learnMore: boolean
  email: string
  validEmail: boolean
  loading: boolean
  uploaded: boolean
}

export default function App () {
  const [state, setState] = useState<AppState>({
    email: '',
    learnMore: false,
    loading: false,
    uploaded: false,
    validEmail: false
  })

  const handleOnChange = (email: string) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (re.test(email)) {
      setState(prevState => {
        return { ...prevState, validEmail: true }
      })
    } else {
      setState(prevState => {
        return { ...prevState, validEmail: false }
      })
    }
  }

  const send = () => {
    setState(prevState => {
      return { ...prevState, loading: true }
    })

    const options = {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'POST',
        'Access-Control-Allow-Headers':
          'Origin, Content-Type, X-Auth-Token, Authorization, Accept,charset,boundary,Content-Length'
      }
    }

    axios
      .post(
        'https://app2.buildingfacademanager.com/api/website/lanch',
        { email: state.email },
        options
      )
      .catch(error => {
        console.log(error)
      })

    setState(prevState => {
      return { ...prevState, loading: false, uploaded: true }
    })
  }

  return (
    <>
      <div className='overlay d-flex align-items-center justify-content-center pb-3 px-3 text-white noselect'>
        <Row>
          <Col
            className='d-none d-lg-block'
            lg='6'
            style={{
              verticalAlign: 'middle'
            }}
          >
            <img
              style={{
                float: 'right',
                position: 'relative',
                height: '180px',
                marginTop: '20px'
              }}
              src='./logo.png'
            />
          </Col>
          <Col className='d-none d-lg-block' lg='6'>
            <h1 className='display-4 pl-3 pb-3'>
              building
              <br />
              facade
              <br />
              manager
              <br />
            </h1>
          </Col>
          <Col md='12' className='d-md-block d-lg-none'>
            <h1
              style={{ fontSize: '2.5rem' }}
              className='display-4 pl-3 pb-3 text-center'
            >
              building
              <br />
              facade
              <br />
              manager
              <br />
            </h1>
          </Col>
          <Col xs='12' className='text-center d-md-block d-lg-none'>
            <h6>Specialist Software for Auditing and Managing Facades</h6>
          </Col>
          <Col xs='12' className='text-center d-none d-lg-block d-lg-none'>
            <h3>Specialist Software for Auditing and Managing Facades</h3>
          </Col>
          <Col lg='3' className='d-none d-lg-block' />
          <Col className='d-none d-lg-block text-center mt-3' lg='6'>
            The Building Facade Manager team produces a 3D digital twin of your
            building’s facade to assist with data organisation, data
            comprehension, auditing, risk management, project management,
            analytics, and forecasting.
          </Col>
          <Col md='12' className='d-md-block d-lg-none  text-center mt-3'>
            <small>
              The Building Facade Manager team produces a 3D digital twin of
              your building’s facade to assist with data organisation, data
              comprehension, auditing, risk management, project management,
              analytics, and forecasting.
            </small>
          </Col>
          <Col lg='3' className='d-none d-lg-block' />
          <Col lg='12' className='text-center mt-3'>
            <div>
              {state.uploaded ? (
                <div className=' mt-2'>
                  <div className='text-center'>
                    <h5 className='mb-2'>Thankyou</h5>
                  </div>
                </div>
              ) : state.loading ? (
                <div className='mt-4'>
                  <Spinner animation='border' role='status' />
                </div>
              ) : !state.learnMore ? (
                <Button
                  className='mt-4'
                  onClick={() =>
                    setState(prevState => {
                      return { ...prevState, learnMore: true }
                    })
                  }
                >
                  Learn more
                </Button>
              ) : (
                <div className='d-flex align-items-center justify-content-center mt-2'>
                  <div className='text-center'>
                    <Form.Group
                      style={{ width: '250px' }}
                      className='text-center'
                    >
                      <Form.Label className='mb-2'>
                        Email me when you launch
                      </Form.Label>
                      <Form.Control
                        onChange={e => {
                          handleOnChange(e.target.value)
                          setState(prevState => {
                            return { ...prevState, email: e.target.value }
                          })
                        }}
                        type='email'
                        placeholder='Enter email'
                      />
                    </Form.Group>
                    <Button
                      onClick={() => send()}
                      disabled={!state.validEmail}
                      className='mt-2 text-center'
                    >
                      Subscribe
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </Col>
          <Col className='d-md-block d-lg-none' style={{ height: '60px' }} />
        </Row>
      </div>
      <div className='wrapper'>
        <video
          // @ts-ignore
          type='video/mp4'
          src='abstract.mp4'
          className='video'
          autoPlay={true}
          muted={true}
          loop={true}
          controls={false}
          playsInline={true}
        />
      </div>
      <div className='center-bottom text-light text-center'>
        <a href='mailto:info@buildingfacademanager.com?subject = Info'>
          <small>info@buildingfacademanager.com</small>
        </a>{' '}
        <Link to={'eula'}>
          <small>EULA</small>
        </Link>
      </div>
    </>
  )
}
